module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/id_1-aa92803a8db1655d732ced8d7edc367f.jpg";